import { render, staticRenderFns } from "./card-registrationProgram.vue?vue&type=template&id=26043bba&scoped=true&"
import script from "./card-registrationProgram.vue?vue&type=script&lang=js&"
export * from "./card-registrationProgram.vue?vue&type=script&lang=js&"
import style0 from "./card-registrationProgram.vue?vue&type=style&index=0&id=26043bba&prod&lang=scss&scoped=true&"
import style1 from "./card-registrationProgram.vue?vue&type=style&index=1&id=26043bba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26043bba",
  null
  
)

export default component.exports